import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import { CompleteTaskByReminder } from "data/hub/actions";
import { DismissReminder } from "data/reminders/actions";

import { OpenReminderRescheduleModal } from "components/ReminderRescheduleModal/actions";

import { useUpcomingReminders } from "./hooks";
import Container from "./Container";

export function Connector({ client, ...callbacks }) {
  const [showAll, setShowAll] = React.useState(false);
  const remindersFetch = useUpcomingReminders(client.id);

  return (
    <Container
      {...remindersFetch}
      {...client}
      showAll={showAll}
      onShowMore={() => {
        setShowAll(!showAll);
      }}
      {...callbacks}
    />
  );
}

Connector.propTypes = {
  client: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

Connector.defaultProps = {};

const mapStateToProps = () => {
  return () => {
    return {};
  };
};

const mapDispatchToProps = (dispatch, { location, history }) => {
  return {
    onNavigate: (clientWorkflowId) => {
      const locationParts = location?.pathname?.split?.("/");
      if (
        locationParts &&
        locationParts[locationParts.length - 1] !== clientWorkflowId
      ) {
        history.push(`./${clientWorkflowId}`);
      }
    },
    onCompleteTask: ({ client, task }, onSuccess) => {
      dispatch(CompleteTaskByReminder(task.id, client.id, onSuccess));
    },
    onDismiss: ({ id, client, task }) => {
      dispatch(
        DismissReminder({
          id: id,
          clientId: client.id,
          clientWorkflowId: task?.clientWorkflow.id,
          taskId: task?.id,
        })
      );
    },
    onReschedule: ({ client, task, ...otherProps }) => {
      dispatch(
        OpenReminderRescheduleModal({
          ...otherProps,
          clientId: client.id,
          clientWorkflowId: task?.clientWorkflow.id,
          taskId: task?.id,
        })
      );
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Connector)
);
